import React from 'react';
import { marked } from 'marked';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const MarkdownToHtml = ({ content, className }) => {
  if (!content || !content.length) return <></>;

  marked.setOptions({
    gfm: true,
    tables: true,
    breaks: false,
    pedantic: false,
    sanitize: false,
    smartLists: true,
    smartypants: false,
  });
  return (
    <>
      <article className={clsx('prose font-body', className)} dangerouslySetInnerHTML={{ __html: marked.parse(content) }} />
    </>
  );
};

MarkdownToHtml.propTypes = {
  content: PropTypes.string.isRequired,
  className: PropTypes.string,
};

MarkdownToHtml.defaultProps = {
  className: undefined,
};

export default MarkdownToHtml;
